import React, { useState, useEffect } from "react";
import {
    languageChange,
    currentSelectedLanguage,
} from "../../../../StateManagement/actions";
import { useSelector, useDispatch } from "react-redux";
import FeatureTooltip from "./ToolTipDisplay"
import { Send, Share } from "lucide-react";
import { Template } from "ckeditor5";
import APIRequest from "../../../../Services/commonAPIConsumer";
import Alert from "../../../Controls/Alerts/Alerts";
import LoadingSpinner from "../../../Controls/Spinner/LoadingSpinner";
import { setDocumentTemplates, setDocumentTemplateName, storeTemplateIdentifyLeakers } from "../../../../StateManagement/actions";
import DualListSelector from "./DualListSelector";
const CreateTemplate = ({
    isOpen,
    template,
    handleCancel,
    sortedColumns,
    LEVEL1_ALLOWED,
    LEVEL2_ALLOWED,
    isFromSettings = false,
    securityLevelValue,
    showManagePopup,
    maxReadsText,
    maxViewsPerDocumentText,
    maxPrintsPerReaderText,
    maxPrintsPerDocumentText,
    Domains,
    ConstContinents,
    ConstMultipleIps
}) => {
    const selectedLanguage = useSelector(currentSelectedLanguage);
    const [securityLevel, setSecurityLevel] = useState(1);
    const [templateName, setTemplateName] = useState("");
    const [templateNamefromsettings, setTemplateNamefromsettings] = useState("");
    const [selectedFeatures, setSelectedFeatures] = useState([]);
    const [alertMsg, setAlertMsg] = useState("");
    const [alertType, setAlertType] = useState("");
    const [alertClass, setAlertClass] = useState("alertindex");
    const [openLoader, setOpen] = useState(false);
    const dispatch = useDispatch();
    const TemplatesData = useSelector((state) => state.documentTemplates.docTemplateOptions);
    const templateIdentifyLeakers = useSelector((state) => state.templateIdentifyLeakers);
    const idLeakersType = useSelector((state) => state.idLeakers.idLeakersType);
    const [openLoaderSearch, setOpenLoaderSearch] = useState(false);
    const [maxReadsPerReader, setMaxReadsPerReader] = useState(maxReadsText);
    const [maxViewsPerDocument, setMaxViewsPerDocument] = useState(maxViewsPerDocumentText);
    const [maxPrintsPerReader, setMaxPrintsPerReader] = useState(maxPrintsPerReaderText);
    const [maxPrintsPerDocument, setMaxPrintsPerDocument] = useState(maxPrintsPerDocumentText);
    const [restrictToDomains, setRestrictToDomains] = useState(Domains || "");
    const [allowedIP, setAllowedIP] = useState(() => {
        if (Array.isArray(ConstMultipleIps)) return ConstMultipleIps.filter(Boolean).join(",");
        return ConstMultipleIps || "";
    });
    const [bannedRegions, setBannedRegions] = useState(() => {
        if (Array.isArray(ConstContinents)) return ConstContinents.map(Number).filter(n => !isNaN(n));
        return [];
    });
    const cipherTextData = useSelector((state) => state.identifyLeakers.cipherText);
    const floatingTextData = useSelector((state) => state.identifyLeakers.floatingText);
    useEffect(() => {
        setMaxReadsPerReader(maxReadsText || "");
        setMaxViewsPerDocument(maxViewsPerDocumentText || "");
        setMaxPrintsPerReader(maxPrintsPerReaderText || "");
        setMaxPrintsPerDocument(maxPrintsPerDocumentText || "");
        if (!isOpen) return;
        setRestrictToDomains(Domains || "");
        setAllowedIP(
            Array.isArray(ConstMultipleIps)
                ? ConstMultipleIps.filter(Boolean).join(",")
                : (ConstMultipleIps || "")
        );
        setBannedRegions(
            Array.isArray(ConstContinents)
                ? ConstContinents.map(Number).filter(n => !isNaN(n))
                : []
        );
    }, [maxReadsText, maxViewsPerDocumentText, maxPrintsPerReaderText, maxPrintsPerDocumentText]);
    // useEffect(() => {
    //     dispatch(storeTemplateIdentifyLeakers({
    //         cipherText: cipherTextData || [],
    //         floatingText: floatingTextData || []
    //     }));
    // }, []);

    // useEffect(() => {
    //     setTimeout(
    //         () => {
    //             setAlertMsg("");
    //             setAlertType("");
    //             setAlertClass("alertindex");
    //         },
    //         5000
    //     );
    // }, [alertType]);

    const SecurityLevel1 = () => {
        setSecurityLevel(prev => (prev >= 1 ? 1 : 1));
    };
    const SecurityLevel2 = () => {
        setSecurityLevel(prev => {
            if (prev >= 2) return 1;
            return 2;
        });
    };
    const SecurityLevel3 = () => {
        setSecurityLevel(prev => {
            if (prev === 3) return 2;
            return 3;
        });
    };
    const TOOLTIP_LABEL_MAP = {
        "Send verification code (Text)": selectedLanguage.LstLanguageCodes.UI_SendVerificationcodeText,
        "Send verification code (Email)": selectedLanguage.LstLanguageCodes.UI_SendVerificationcodeEmail,
        "Proof of sending": selectedLanguage.LstLanguageCodes.UI_ProofOfSending,
        "Notification of reading": selectedLanguage.LstLanguageCodes.UI_NotificationofReading,
        "Voting": selectedLanguage.LstLanguageCodes.UI_Voting,
        "Share votes": selectedLanguage.LstLanguageCodes.UI_ShareVotes,
        "Display distribution list": selectedLanguage.LstLanguageCodes.UI_DisplayDistributionlist,
        "ID Leakers": selectedLanguage.LstLanguageCodes.UI_IDLeakers,
        "Timestamp": selectedLanguage.LstLanguageCodes.UI_TimeStamp,
        "Can print": selectedLanguage.LstLanguageCodes.UI_CanPrint,
        "Allow responses to": selectedLanguage.LstLanguageCodes.UI_AllowResponsesTo,
        "E-Disclosure": selectedLanguage.LstLanguageCodes.UI_EDisclosure,
    };
    const handleTemplateCreation = async () => {
        if (!templateName.trim()) {
            setAlertMsg(selectedLanguage.LstLanguageCodes.UI_Pleaseenteratemplatename);
            setAlertType("warning");
            return;
        }
        if (TemplatesData && TemplatesData.some(t => t.templateName.toLowerCase() === templateName.trim().toLowerCase())) {
            setAlertMsg(selectedLanguage.LstLanguageCodes.UI_Templatenamealreadyexists);
            setAlertType("warning");
            return;
        }
        if (!selectedFeatures || selectedFeatures.length === 0) {
            setAlertMsg(selectedLanguage.LstLanguageCodes.UI_PleaseSelectAtleastOneFeature);
            setAlertType("warning");
            return;
        }
        const selectedLabels = selectedFeatures.map(f => f.label || f);

        if (selectedLabels.includes(selectedLanguage.LstLanguageCodes.UI_MaxReadsperReader) && !(parseInt(maxReadsPerReader) > 0) && securityLevel !== 1) {
            setAlertMsg(selectedLanguage.LstLanguageCodes.UI_MaxReadsperReaderCannotBeEmpty);
            setAlertType("warning");
            return;
        }
        if (selectedLabels.includes(selectedLanguage.LstLanguageCodes.UI_MaxviewsPerDocument) && !(parseInt(maxViewsPerDocument) > 0)) {
            setAlertMsg(selectedLanguage.LstLanguageCodes.UI_MaxviewsPerDocumentCannotBeEmpty);
            setAlertType("warning");
            return;
        }
        const readsSelected = selectedLabels.includes(selectedLanguage.LstLanguageCodes.UI_MaxReadsperReader);
        const viewsSelected = selectedLabels.includes(selectedLanguage.LstLanguageCodes.UI_MaxviewsPerDocument);
        if (readsSelected === viewsSelected && parseInt(maxReadsPerReader) > parseInt(maxViewsPerDocument)) {
            setAlertMsg(selectedLanguage.LstLanguageCodes.UI_Readsperreadercannotexceedviewsperdocument);
            setAlertType("warning");
            return;
        }
        const isCanPrintSelected = selectedLabels.includes(
            selectedLanguage.LstLanguageCodes.UI_CanPrint
        );

        try {
            setOpen(true);
            setOpenLoaderSearch(true);
            const DocumentTemplateOptions = {
                RDocsLevel: securityLevel,
                TemplateName: templateName,

                AllowResponsesTo: selectedLabels.includes(selectedLanguage.LstLanguageCodes.UI_AllowResponsesTo),
                CanPrint: selectedLabels.includes(selectedLanguage.LstLanguageCodes.UI_CanPrint),
                IDLeakers: selectedLabels.includes(selectedLanguage.LstLanguageCodes.UI_IDLeakers),
                DistributionList: selectedLabels.includes(selectedLanguage.LstLanguageCodes.UI_DisplayDistributionlist),
                NotificationOfReading: selectedLabels.includes(selectedLanguage.LstLanguageCodes.UI_NotificationofReading),
                ProofOfSending: selectedLabels.includes(selectedLanguage.LstLanguageCodes.UI_ProofOfSending),
                VoteSharing: selectedLabels.includes(selectedLanguage.LstLanguageCodes.UI_ShareVotes),
                Timestamp: selectedLabels.includes(selectedLanguage.LstLanguageCodes.UI_TimeStamp),
                Voting: selectedLabels.includes(selectedLanguage.LstLanguageCodes.UI_Voting),
                SendVerifiCationCodeText: selectedLabels.includes(selectedLanguage.LstLanguageCodes.UI_SendVerificationcodeText),
                SendVerifiCationCodeEmail: selectedLabels.includes(selectedLanguage.LstLanguageCodes.UI_SendVerificationcodeEmail),
                EDisclosure: selectedLabels.includes(selectedLanguage.LstLanguageCodes.UI_EDisclosure),

                MaxReadsPerReader: selectedLabels.includes(selectedLanguage.LstLanguageCodes.UI_MaxReadsperReader)
                    ? (parseInt(maxReadsPerReader) || 0)
                    : 0,
                MaxViewsPerDocument: selectedLabels.includes(selectedLanguage.LstLanguageCodes.UI_MaxviewsPerDocument)
                    ? (parseInt(maxViewsPerDocument) || 0)
                    : 0,
                MaxPrintsPerReader: selectedLabels.includes(selectedLanguage.LstLanguageCodes.UI_CanPrint)
                    ? (parseInt(maxPrintsPerReader) || 0)
                    : 0,
                MaxPrintsPerDocument: selectedLabels.includes(selectedLanguage.LstLanguageCodes.UI_CanPrint)
                    ? (parseInt(maxPrintsPerDocument) || 0)
                    : 0,

                CipherText: templateIdentifyLeakers.cipherText,
                FloatingText: templateIdentifyLeakers.floatingText,
                IdLeakersType: idLeakersType,
                Ips: selectedLabels.includes(selectedLanguage.LstLanguageCodes.UI_AllowedIP)
                    ? (allowedIP ? allowedIP.split(",").map(ip => ip.trim()).filter(Boolean) : [])
                    : [],
                Regions: selectedLabels.includes(selectedLanguage.LstLanguageCodes.UI_BannedRegions)
                    ? (Array.isArray(bannedRegions) ? bannedRegions : [])
                    : [],
                Domains: selectedLabels.includes(selectedLanguage.LstLanguageCodes.UI_RestrictToDomains)
                    ? (restrictToDomains || "")
                    : "",
            };

            if (DocumentTemplateOptions.Voting === false && DocumentTemplateOptions.VoteSharing === true) {
                setAlertMsg(selectedLanguage.LstLanguageCodes.UI_VotingIsMandatory);
                setAlertType("warning");
                setOpen(false);
                return;
            }
            const formData = new FormData();
            formData.append("DocumentTemplateOptions", JSON.stringify(DocumentTemplateOptions));
            const response = await APIRequest.POST(
                formData,
                `${process.env.REACT_APP_API + "/docs/DocumentTemplate"}`
            );
            dispatch(setDocumentTemplates(response?.docTemplateOptions));
            dispatch(storeTemplateIdentifyLeakers({
                cipherText: response?.docTemplateOptions?.cipherText || [],
                floatingText: response?.docTemplateOptions?.floatingText || []
            }));
            //handleCancel();
            setOpen(false);
            setOpenLoaderSearch(false);
            handleCancel();
        } catch (err) {
            console.error("Template creation error:", err);
            setOpen(false);
            setOpenLoaderSearch(false);
        }
    };

    const handleSettingsTemplateCreation = async () => {
        if (!templateNamefromsettings.trim()) {
            setAlertMsg(selectedLanguage.LstLanguageCodes.UI_Pleaseenteratemplatename);
            setAlertType("warning");
            return;
        }
        if (TemplatesData && TemplatesData.some(t => t.templateName.toLowerCase() === templateNamefromsettings.trim().toLowerCase())) {
            setAlertMsg(selectedLanguage.LstLanguageCodes.UI_Templatenamealreadyexists);
            setAlertType("warning");
            return;
        }
        if (!template || !Object.values(template).some(value => value === true)) {
            setAlertMsg(selectedLanguage.LstLanguageCodes.UI_PleaseSelectAtleastOneFeature);
            setAlertType("warning");
            return;
        }
        const MaxReadsPerReader = parseInt(maxReadsPerReader, 10) || 0;
        const MaxViewsPerDocument = parseInt(maxViewsPerDocument, 10) || 0;
        const MaxPrintsPerReader = parseInt(maxPrintsPerReader, 10) || 0;
        const MaxPrintsPerDocument = parseInt(maxPrintsPerDocument, 10) || 0;

        if (MaxReadsPerReader > MaxViewsPerDocument) {
            setAlertMsg(selectedLanguage.LstLanguageCodes.UI_Readsperreadercannotexceedviewsperdocument);
            setAlertType("warning");
            return;
        }
        if (MaxPrintsPerReader > MaxPrintsPerDocument) {
            setAlertMsg(selectedLanguage.LstLanguageCodes.UI_Printsperreadercannotexceedprintspersdocument);
            setAlertType("warning");
            return;

        }
        const DomainStr = Domains || "";
        if (DomainStr !== "" && DomainStr.split(",").length === 1 && DomainStr.length > 190) {
            setAlertMsg(selectedLanguage.LstLanguageCodes.UI_ThedomainmustbelessthanNum);
            setAlertType("warning");
            return;
        }
        if (DomainStr !== "" && DomainStr.split(",").length > 1) {
            let domainvalidation = false;
            DomainStr.split(",").forEach((element) => {
                if (element.length > 190 && !domainvalidation) domainvalidation = true;
            });
            if (domainvalidation) {
                setAlertMsg(selectedLanguage.LstLanguageCodes.UI_ThedomainmustbelessthanNum);
                setAlertType("warning");
                return;
            }
        }
        if (DomainStr !== "" && DomainStr.split(",").length > 10) {
            setAlertMsg(selectedLanguage.LstLanguageCodes.UI_Addupto10domainsseparatedbycomma);
            setAlertType("warning");
            return;
        }
        const settingsDomainList = DomainStr !== "" ? DomainStr.split(",").map(d => d.trim()) : [];
        if (settingsDomainList.length >= 1) {
            const uniqueDomains = new Set();
            for (let domain of settingsDomainList) {
                if (uniqueDomains.has(domain.toLowerCase())) {
                    setAlertMsg(selectedLanguage.LstLanguageCodes.UI_DuplicateDomain);
                    setAlertType("warning");
                    return;
                }
                uniqueDomains.add(domain.toLowerCase());
                const regex = /^[A-Za-z0-9-]+(\.[A-Za-z]{2,})+$/;
                if (!regex.test(domain)) {
                    setAlertMsg(selectedLanguage.LstLanguageCodes.UI_InvalidDomain);
                    setAlertType("warning");
                    return;
                }
            }
        }
        const Ips = Array.isArray(ConstMultipleIps)
            ? ConstMultipleIps.map(ip => ip.trim()).filter(Boolean)
            : (ConstMultipleIps ? String(ConstMultipleIps).split(",").map(ip => ip.trim()).filter(Boolean) : []);
        const allRegionValues = [0, 1, 2, 3, 4, 5];
        const allowedRegions = Array.isArray(ConstContinents)
            ? ConstContinents.map(Number).filter(n => !isNaN(n))
            : allRegionValues;

        const Regions = allowedRegions.length < 6
            ? allRegionValues.filter(v => !allowedRegions.includes(v))
            : [];
        try {
            setOpen(true);
            setOpenLoaderSearch(true);
            const DocumentTemplateOptions = {
                RDocsLevel: securityLevelValue,
                TemplateName: templateNamefromsettings,
                AllowResponsesTo: !!template?.[selectedLanguage.LstLanguageCodes.UI_AllowResponsesTo],
                CanPrint: !!template?.[selectedLanguage.LstLanguageCodes.UI_CanPrint],
                IDLeakers: !!template?.[selectedLanguage.LstLanguageCodes.UI_IDLeakers],
                DistributionList: !!template?.[selectedLanguage.LstLanguageCodes.UI_DisplayDistributionlist],
                NotificationOfReading: !!template?.[selectedLanguage.LstLanguageCodes.UI_NotificationofReading],
                ProofOfSending: !!template?.[selectedLanguage.LstLanguageCodes.UI_ProofOfSending],
                VoteSharing: !!template?.[selectedLanguage.LstLanguageCodes.UI_ShareVotes],
                Timestamp: !!template?.[selectedLanguage.LstLanguageCodes.UI_TimeStamp],
                Voting: !!template?.[selectedLanguage.LstLanguageCodes.UI_Voting],
                SendVerifiCationCodeText: !!template?.[selectedLanguage.LstLanguageCodes.UI_SendVerificationcodeText],
                SendVerifiCationCodeEmail: !!template?.[selectedLanguage.LstLanguageCodes.UI_SendVerificationcodeEmail],
                EDisclosure: !!template?.[selectedLanguage.LstLanguageCodes.UI_EDisclosure],
                MaxReadsPerReader: parseInt(maxReadsPerReader) || 0,
                MaxViewsPerDocument: parseInt(maxViewsPerDocument) || 0,
                MaxPrintsPerReader: parseInt(maxPrintsPerReader) || 0,
                MaxPrintsPerDocument: parseInt(maxPrintsPerDocument) || 0,

                IdLeakersType: idLeakersType,
                CipherText: templateIdentifyLeakers.cipherText,
                FloatingText: templateIdentifyLeakers.floatingText,
                Ips: Ips,
                Regions: Regions,
                Domains: DomainStr,
            };

            if (DocumentTemplateOptions.Voting === false && DocumentTemplateOptions.VoteSharing === true) {
                setAlertMsg(selectedLanguage.LstLanguageCodes.UI_VotingIsMandatory);
                setAlertType("warning");
                setOpen(false);
                return;
            }
            const formData = new FormData();
            formData.append("DocumentTemplateOptions", JSON.stringify(DocumentTemplateOptions));
            const response = await APIRequest.POST(
                formData,
                `${process.env.REACT_APP_API + "/docs/DocumentTemplate"}`
            );
            dispatch(setDocumentTemplates(response?.docTemplateOptions));
            dispatch(setDocumentTemplateName(response?.docTemplateOptions.filter(t => t.templateName === templateNamefromsettings)));
            setOpen(false);
            setOpenLoaderSearch(false);
            if (typeof handleCancel === "function") {
                handleCancel();
            }
        } catch (err) {
            console.error("Template creation error:", err);
            setOpen(false);
            setOpenLoaderSearch(false);
        }
        handleCancel();

    };

    if (!isOpen) {
        return null;
    }
    return (
        <>
            {isFromSettings === false && (
                <div>
                    <div
                        className="modal"
                        id="MoveFolder"
                        style={{ display: "block", backgroundColor: "#8080801c" }}
                    >
                        <div className="modal-dialog modal-dialog-centered modal-customelg" style={{ maxWidth: '830px' }}>
                            <div className="modal-content">
                                <div className="modal-header pb-1">
                                    <h4 className="d-flex align-items-center text-danger fw-bold">
                                        {selectedLanguage.LstLanguageCodes.UI_CreateTemplateText}
                                    </h4>
                                </div>
                                <div className="modal-body justify-content-center">
                                    <div></div>
                                    <div className="d-flex justify-content-center gap-3 mt-2">
                                        <ul className="ks-cboxtags ps-0 mx-margin ms-2">
                                            <li style={{ width: '230px' }}>
                                                <input
                                                    className="btn-check"
                                                    type="checkbox"
                                                    name="securitylevels"
                                                    id="securitylevel1"
                                                    checked={securityLevel >= 1}
                                                    disabled
                                                    onChange={SecurityLevel1}
                                                />
                                                <label
                                                    className="views pb-3p"
                                                    htmlFor="securitylevel1"
                                                    title={selectedLanguage.LstLanguageCodes.UI_TrackViews}
                                                >
                                                    <span className="w-106px truncate">
                                                        {selectedLanguage.LstLanguageCodes.UI_TrackViews}
                                                    </span>
                                                </label>
                                            </li>
                                        </ul>
                                        <ul className="ks-cboxtags ps-0 mx-margin ms-12px">
                                            <li style={{ width: '230px' }}>
                                                <input
                                                    className="btn-check"
                                                    type="checkbox"
                                                    name="securitylevels"
                                                    id="securitylevel2"
                                                    checked={securityLevel >= 2}
                                                    onChange={SecurityLevel2}
                                                />
                                                <label
                                                    className="readers pb-3p"
                                                    htmlFor="securitylevel2"
                                                    title={selectedLanguage.LstLanguageCodes.UI_TrackReaders}
                                                >
                                                    <span className="w-118px truncate">
                                                        {selectedLanguage.LstLanguageCodes.UI_TrackReaders}
                                                    </span>
                                                </label>
                                            </li>
                                        </ul>
                                        <ul className="ks-cboxtags ps-0 mx-margin ms-12px">
                                            <li style={{ width: '230px' }}>
                                                <input
                                                    className="btn-check"
                                                    type="checkbox"
                                                    name="securitylevels"
                                                    id="securitylevel3"
                                                    checked={securityLevel >= 3}
                                                    onChange={SecurityLevel3}
                                                />
                                                <label
                                                    className="restrict pb-3p"
                                                    htmlFor="securitylevel3"
                                                    title={selectedLanguage.LstLanguageCodes.UI_LimitReaders}
                                                >
                                                    <span className="w-120px truncate">
                                                        {selectedLanguage.LstLanguageCodes.UI_LimitReaders}
                                                    </span>
                                                </label>
                                            </li>
                                        </ul>
                                    </div>
                                    <DualListSelector
                                        availableItems={sortedColumns}
                                        securityLevel={securityLevel}
                                        isOpen={isOpen}
                                        onChange={(selected) => setSelectedFeatures(selected)}
                                        LEVEL1_ALLOWED={LEVEL1_ALLOWED}
                                        LEVEL2_ALLOWED={LEVEL2_ALLOWED}
                                        onMaxValueChange={(vals) => {
                                            console.log("Max values changed:", vals);
                                            setMaxReadsPerReader(prev => prev !== vals.maxReadsPerReader ? vals.maxReadsPerReader : prev);
                                            setMaxViewsPerDocument(prev => prev !== vals.maxViewsPerDocument ? vals.maxViewsPerDocument : prev);
                                            setMaxPrintsPerReader(prev => prev !== vals.maxPrintsPerReader ? vals.maxPrintsPerReader : prev);
                                            setMaxPrintsPerDocument(prev => prev !== vals.maxPrintsPerDocument ? vals.maxPrintsPerDocument : prev);
                                        }}
                                        maxReadsText={maxReadsText}
                                        maxViewsPerDocumentText={maxViewsPerDocumentText}
                                        maxPrintsPerReaderText={maxPrintsPerReaderText}
                                        maxPrintsPerDocumentText={maxPrintsPerDocumentText}
                                        onRestrictionValueChange={({ restrictToDomains, allowedIP, bannedRegions }) => {
                                            setRestrictToDomains(prev => prev !== restrictToDomains ? restrictToDomains : prev);
                                            setAllowedIP(prev => prev !== allowedIP ? allowedIP : prev);
                                            setBannedRegions(prev => {
                                                if (Array.isArray(prev) && Array.isArray(bannedRegions)) {
                                                    if (prev.length === bannedRegions.length && prev.every((v, i) => v === bannedRegions[i])) {
                                                        return prev;
                                                    }
                                                }
                                                return bannedRegions;
                                            });
                                        }}
                                        onAlert={(msg) => { setAlertMsg(msg); setAlertType("warning"); }}
                                        Domains={restrictToDomains}
                                        ConstContinents={bannedRegions}
                                        ConstMultipleIps={allowedIP}
                                        restrictToDomainLabel={selectedLanguage.LstLanguageCodes.UI_RestrictToDomains}
                                        allowedIPLabel={selectedLanguage.LstLanguageCodes.UI_AllowedIP}
                                        bannedRegionsLabel={selectedLanguage.LstLanguageCodes.UI_BannedRegions}

                                    />
                                </div>
                                <div className="d-flex justify-content-between align-items-center mb-3 mx-3 mt-2">
                                    <input
                                        type="text"
                                        maxLength={25}
                                        value={templateName}
                                        onChange={(e) => setTemplateName(e.target.value)}
                                        style={{ width: '324px', flexShrink: 0, marginLeft: "20px" }}
                                        placeholder={"Enter template name"}
                                    />
                                    <div className="d-flex gap-2">
                                        <button
                                            type="button"
                                            className="btn btn-danger px-4"
                                            onClick={handleCancel}
                                        >
                                            {selectedLanguage.LstLanguageCodes.UI_Cancel}
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-primary px-4"
                                            onClick={handleTemplateCreation}
                                        >
                                            {selectedLanguage.LstLanguageCodes.UI_CreateTemplate}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {isFromSettings === true && (
                <div>
                    <div
                        className="modal"
                        id="MoveFolder"
                        style={{ display: "block", backgroundColor: "#8080801c" }}
                    >
                        <div
                            className="modal-dialog modal-dialog-centered modal-customelg"
                            style={{ maxWidth: "464px" }}
                        >
                            <div className="modal-content">
                                <div className="modal-header pb-1">
                                    <h4 className="d-flex align-items-center text-danger fw-bold" style={{ color: "#dc3545 !important" }}>
                                        {selectedLanguage.LstLanguageCodes.UI_CreateTemplateText}
                                    </h4>
                                </div>
                                <div style={{ marginTop: "16px", maxWidth: "420px" }}>
                                    <div style={{ marginBottom: "16px", marginLeft: "40px" }}>
                                        <label
                                            style={{
                                                display: "block",
                                                marginBottom: "6px",
                                                fontWeight: "600",
                                                color: "#5a6b7b"
                                            }}
                                        >
                                            {selectedLanguage.LstLanguageCodes.UI_TemplateName}:
                                        </label>
                                        <input
                                            type="text"
                                            value={templateNamefromsettings}
                                            maxLength={25}
                                            onChange={(e) => setTemplateNamefromsettings(e.target.value)}
                                             placeholder="Enter template name"
                                            style={{
                                                width: "100%",
                                                padding: "8px 10px",
                                                borderRadius: "6px",
                                                border: "1px solid #ddd"
                                            }}
                                        />
                                    </div>
                                    <div style={{ marginLeft: "40px" }}>
                                        <label
                                            style={{
                                                display: "block",
                                                marginBottom: "6px",
                                                fontWeight: "600",
                                                color: "#5a6b7b"
                                            }}
                                        >
                                            {selectedLanguage.LstLanguageCodes.UI_FeatureSelected}:
                                        </label>
                                        <div
                                            className="feature-panel"
                                            style={{
                                                border: "1px solid #ddd",
                                                borderRadius: "8px",
                                                padding: "10px",
                                                backgroundColor: "#fff"
                                            }}
                                        >
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    marginBottom: "6px"
                                                }}
                                            >
                                                <h6
                                                    style={{
                                                        color:
                                                            securityLevelValue === 2
                                                                ? "#f0ad00"
                                                                : securityLevelValue === 1
                                                                    ? "#5a8eff"
                                                                    : "#dc3545",
                                                        margin: 0,
                                                    }}
                                                >
                                                    {securityLevelValue === 1
                                                        ? selectedLanguage.LstLanguageCodes.UI_TrackViews
                                                        : securityLevelValue === 2
                                                            ? selectedLanguage.LstLanguageCodes.UI_TrackReaders
                                                            : selectedLanguage.LstLanguageCodes.UI_LimitReaders}
                                                </h6>
                                            </div>
                                            <div
                                                className="feature-list"
                                                style={{
                                                    maxHeight: "220px",
                                                    overflowY: "auto",
                                                    paddingRight: "4px"
                                                }}
                                            >
                                                {(() => {
                                                    const KNOWN_FEATURE_KEYS = [
                                                        selectedLanguage.LstLanguageCodes.UI_AllowResponsesTo,
                                                        selectedLanguage.LstLanguageCodes.UI_CanPrint,
                                                        selectedLanguage.LstLanguageCodes.UI_IDLeakers,
                                                        selectedLanguage.LstLanguageCodes.UI_DisplayDistributionlist,
                                                        selectedLanguage.LstLanguageCodes.UI_NotificationofReading,
                                                        selectedLanguage.LstLanguageCodes.UI_ProofOfSending,
                                                        selectedLanguage.LstLanguageCodes.UI_ShareVotes,
                                                        selectedLanguage.LstLanguageCodes.UI_TimeStamp,
                                                        selectedLanguage.LstLanguageCodes.UI_Voting,
                                                        selectedLanguage.LstLanguageCodes.UI_SendVerificationcodeText,
                                                        selectedLanguage.LstLanguageCodes.UI_SendVerificationcodeEmail,
                                                        selectedLanguage.LstLanguageCodes.UI_EDisclosure,
                                                        selectedLanguage.LstLanguageCodes.UI_MaxReadsperReader,
                                                        selectedLanguage.LstLanguageCodes.UI_MaxviewsPerDocument,
                                                    ];
                                                    const boolFeatures = template
                                                        ? KNOWN_FEATURE_KEYS
                                                            .filter(key => {
                                                                if (!template[key]) return false;
                                                                if (key === selectedLanguage.LstLanguageCodes.UI_MaxReadsperReader) {
                                                                    return parseInt(maxReadsText) > 0;
                                                                }
                                                                if (key === selectedLanguage.LstLanguageCodes.UI_MaxviewsPerDocument) {
                                                                    return parseInt(maxViewsPerDocumentText) > 0;
                                                                }
                                                                return template[key] === true;
                                                            })
                                                            .map(key => [key, template[key]])
                                                        : [];
                                                    const restrictionFeatures = [];
                                                    const domainVal = restrictToDomains || "";
                                                    if (domainVal && domainVal.trim() !== "") {
                                                        restrictionFeatures.push({
                                                            key: selectedLanguage.LstLanguageCodes.UI_RestrictToDomains,
                                                            label: selectedLanguage.LstLanguageCodes.UI_RestrictToDomains
                                                        });
                                                    }
                                                    const ipVal = Array.isArray(ConstMultipleIps)
                                                        ? ConstMultipleIps.filter(Boolean).join(",")
                                                        : (ConstMultipleIps || "");
                                                    if (ipVal && ipVal.trim() !== "") {
                                                        restrictionFeatures.push({
                                                            key: selectedLanguage.LstLanguageCodes.UI_AllowedIP,
                                                            label: selectedLanguage.LstLanguageCodes.UI_AllowedIP
                                                        });
                                                    }
                                                    const regionVal = Array.isArray(bannedRegions) ? bannedRegions : [];
                                                    if (regionVal.length > 0 && regionVal.length < 6) {
                                                        restrictionFeatures.push({
                                                            key: selectedLanguage.LstLanguageCodes.UI_BannedRegions,
                                                            label: selectedLanguage.LstLanguageCodes.UI_BannedRegions
                                                        });
                                                    }


                                                    const totalCount = boolFeatures.length + restrictionFeatures.length;

                                                    if (totalCount === 0) {
                                                        return <p className="text-muted">{selectedLanguage.LstLanguageCodes.UI_NoFeaturesEnabled || "No features enabled"}</p>;
                                                    }

                                                    let rowIndex = 0;
                                                    return (
                                                        <>
                                                            {boolFeatures.map(([key]) => {
                                                                rowIndex++;
                                                                return (
                                                                    <div
                                                                        key={key}
                                                                        className="feature-row"
                                                                        style={{
                                                                            border: "1px solid #e0e0e0",
                                                                            borderRadius: "6px",
                                                                            padding: "6px 8px",
                                                                            marginBottom: "6px",
                                                                            backgroundColor: "#fafafa",
                                                                        }}
                                                                    >
                                                                        <span style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                                            <span>{rowIndex}. {key}</span>
                                                                            <FeatureTooltip label={TOOLTIP_LABEL_MAP[key] || key} selectedLanguage={selectedLanguage} />
                                                                        </span>
                                                                    </div>
                                                                );
                                                            })}
                                                            {restrictionFeatures.map((rf) => {
                                                                rowIndex++;
                                                                return (
                                                                    <div
                                                                        key={rf.key}
                                                                        className="feature-row"
                                                                        style={{
                                                                            border: "1px solid #e0e0e0",
                                                                            borderRadius: "6px",
                                                                            padding: "6px 8px",
                                                                            marginBottom: "6px",
                                                                            backgroundColor: "#fafafa",
                                                                        }}
                                                                    >
                                                                        <span style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                                            <span>{rowIndex}. {rf.label}</span>
                                                                            <FeatureTooltip label={rf.label} selectedLanguage={selectedLanguage} />
                                                                        </span>
                                                                    </div>
                                                                );
                                                            })}
                                                        </>
                                                    );
                                                })()}
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-end mb-3 me-3 mt-2">
                                    <button
                                        type="button"
                                        className="btn btn-danger px-4 me-1"
                                        onClick={handleCancel}
                                    >
                                        {selectedLanguage.LstLanguageCodes.UI_Cancel}
                                    </button>
                                    <button
                                        type="button"
                                        style={{ marginRight: "23px" }}
                                        className="btn btn-primary px-4 ms-3"
                                        onClick={handleSettingsTemplateCreation}
                                    >
                                        {selectedLanguage.LstLanguageCodes.UI_CreateTemplate}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <Alert
                alertType={alertType}
                alertMsg={alertMsg}
                setAlertMsg={setAlertMsg}
                setAlertType={setAlertType}
                className={alertClass}
            />
            {openLoader ? (
                <LoadingSpinner
                    className={openLoaderSearch ? "backgroundTransprent" : undefined}
                />
            ) : null}
        </>
    );
};

export default CreateTemplate;